import React from 'react';
import styles from '../layout/AdminLayout.module.css';
import DashboardStatsCards from './DashboardStatsCards';
import DashboardGraphs from './DashboardGraphs';
import DashboardStatGraphs from './DashboardStatGraphs';

const DashboardComponent: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <div>
        <b className={styles.pageTitle}>대시보드</b>
      </div>
      
      <div className={styles.pageContent}>
        <DashboardStatsCards />
      </div>
      
      <div className={styles.pageContent}>
        <DashboardGraphs />
      </div>
      
      <div className={styles.pageContent}>
        <DashboardStatGraphs />
      </div>
    </div>
  );
};

export default DashboardComponent;